<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <router-link :to="{ name: 'index' }" exact>
        <b-navbar-brand class="pl-3">
          <h2 class="mb-0"> <b-img src="../LogoBlanco50.png" width="35px"></b-img><span class="mt-2 ml-3">Instituto
              Fueguino de Enseñanza Inglesa</span></h2>
        </b-navbar-brand>
      </router-link>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-if="$currentUser.id" #button-content>
              <b-avatar size="sm" icon="people-fill" variant="gray"></b-avatar>
              {{ $currentUser.display_name }}
            </template>
            <!-- <b-dropdown-item href="#">Profile</b-dropdown-item>-->
            <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { AuthService } from '../services/auth.service'

export default {
  name: 'Header',

  methods: {
    async logout () {
      await AuthService.makeLogout()
      await this.$store.dispatch('user/removeCurrent')
      this.$session.destroy()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped></style>
